import { isSameYear } from 'date-fns';
import { TFunction } from 'i18next';

export function formatSchedulePreviewRange(dateStartUtc: string | null | undefined, dateEndUtc: string | null | undefined, timeZone: string, t: TFunction<'dates'>) {
    if (!dateStartUtc || !dateEndUtc) {
        return null;
    }
    
    const now = new Date();

    const showYear = !(
        isSameYear(now, new Date(dateStartUtc)) && isSameYear(now, new Date(dateEndUtc))
    );

    const format = showYear ? 'dates:dayMonthYearShort' : 'dates:dayMonth';
    
    const from = t(format, { date: dateStartUtc, tenantTz: timeZone });
    const to = t(format, { date: dateEndUtc, tenantTz: timeZone });

    return from === to ? from : `${ from } - ${ to }`;
}
